module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('div', {
    staticClass: "logo",
    on: {
      "click": _vm.menuClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('svg', {
    attrs: {
      "width": "1039px",
      "height": "256px",
      "viewBox": "0 0 1039 256",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("LING IT")]), _vm._v(" "), _c('desc', [_vm._v("LING IT Logo")]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "x1": "50.0409091%",
      "y1": "2.54931888%",
      "x2": "50.5634165%",
      "y2": "95.6643537%",
      "id": "linearGradient-1"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.9",
      "offset": "12.27%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "50.8307659%",
      "y1": "97.2946503%",
      "x2": "48.9355402%",
      "y2": "4.22457485%",
      "id": "linearGradient-2"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.95",
      "offset": "25.04%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.02",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "97.9051388%",
      "y1": "49.9301877%",
      "x2": "4.53457707%",
      "y2": "51.1621959%",
      "id": "linearGradient-3"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.95",
      "offset": "10.24%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.02",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "49.0697585%",
      "y1": "2.46930084%",
      "x2": "50.6365782%",
      "y2": "95.9048399%",
      "id": "linearGradient-4"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.9",
      "offset": "19.36%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.02",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "49.3048601%",
      "y1": "38.7215666%",
      "x2": "49.9770943%",
      "y2": "95.6137035%",
      "id": "linearGradient-5"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.8",
      "offset": "0%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.02",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "38.6886982%",
      "y1": "49.6708333%",
      "x2": "95.5690355%",
      "y2": "49.6708333%",
      "id": "linearGradient-6"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.9",
      "offset": "0%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.1",
      "offset": "100%"
    }
  })], 1)], 1), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Logo",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-81.000000, -183.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "LING-IT",
      "transform": "translate(81.000000, 183.000000)"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Combined-Shape",
      "fill": "#424242",
      "points": "1011.79894 28.5277769 1038.64253 28.5277769 1038.64253 72.2235372 996.262907 72.2235372 996.262907 227.00129 944.670322 227.00129 944.670322 126.216927 957.216927 126.216927 957.216927 102 944.670322 102 944.670322 72.2235372 902.2907 72.2235372 902.2907 28.5277769 976 28.5277769 976 46.851846 1011.79894 46.851846"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Combined-Shape",
      "fill": "#424242",
      "points": "843.216927 28.5277769 877.897433 28.5277769 877.897433 127 861 127 861 195.439143 877.897433 195.439143 877.897433 227.00129 826.304849 227.00129 826.304849 66.4338547 843.216927 66.4338547"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M521.481477,202.720833 L521.481477,127 L493.234404,127 C493.287984,111.75176 495.788317,97.7485872 500.735476,84.9900695 C505.736801,72.0918589 512.843841,61.0802865 522.056809,51.9550219 C524.847984,49.1904177 527.812294,46.6110548 530.949748,44.2169274 L582.280907,44.2169274 L582.280907,23.9696978 C587.593536,23.3232314 593.095656,23 598.787286,23 C619.494527,23 637.656963,27.4748223 653.275137,36.424601 C668.893311,45.3743798 681.264825,59.2375547 690.39005,78.0145415 L641.429952,98.2830568 C636.867339,87.4029336 630.944806,79.59393 623.662174,74.8558119 C616.379543,70.1176937 608.087996,67.7486701 598.787286,67.7486701 C591.065941,67.7486701 584.046642,69.1964068 577.729179,72.0919234 C571.411715,74.9874401 566.015629,79.1112959 561.540759,84.4636146 C557.065889,89.8159333 553.55624,96.2649418 551.011706,103.810834 C548.467172,111.356726 547.194924,119.77992 547.194924,129.080671 C547.194924,137.503992 548.291689,145.312996 550.485253,152.507916 C552.678817,159.702836 555.969113,165.932491 560.356241,171.197066 C564.743368,176.461642 570.183325,180.541627 576.676273,183.437144 C583.169222,186.33266 590.714968,187.780397 599.313738,187.780397 C604.402806,187.780397 609.316315,187.210077 614.054413,186.069419 C618.792511,184.92876 623.047961,183.086187 626.82089,180.541642 C630.59382,177.997097 633.708634,174.706786 636.165425,170.670611 C638.622217,166.634437 640.2893,161.720906 641.166726,155.929873 L598.787286,155.929873 L598.787286,115.919297 L662.00015,115.919297 L662.00015,161.433855 L696.823447,161.433855 C696.169518,163.87149 695.428927,166.248467 694.601672,168.564792 C690.916484,178.918457 685.915234,188.087456 679.59777,196.072062 C673.280307,204.056669 665.866173,210.725032 657.355145,216.07735 C648.844118,221.429669 639.499676,225.509654 629.32154,228.317428 C619.143405,231.125201 608.438974,232.529067 597.207928,232.529067 C581.765239,232.529067 567.682771,229.98456 554.960101,224.895471 C542.237431,219.806381 531.313647,212.655439 522.188422,203.442432 C521.951412,203.203142 521.715764,202.962609 521.481477,202.720833 Z",
      "id": "Combined-Shape",
      "fill": "#424242"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M403,148.493378 L403,225.619027 L308.797077,105.653426 L308.797077,227.00129 L257.204493,227.00129 L257.204493,175.433855 L272.216927,175.433855 L272.216927,127 L257.204493,127 L257.204493,52.851846 L285.904756,52.851846 L285.904756,28.5277769 L308.797077,28.5277769 L329.584376,55 L319,55 L319,79.2169274 L348.600705,79.2169274 L403,148.493378 Z M404.085422,127 L404.085422,28.5277769 L455.414779,28.5277769 L455.414779,127 L404.085422,127 Z",
      "id": "Combined-Shape",
      "fill": "#424242"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Combined-Shape",
      "fill": "#424242",
      "points": "214.122076 55 195 55 195 123.439143 214.122076 123.439143 214.122076 227.00129 162.529491 227.00129 162.529491 28.5277769 214.122076 28.5277769"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Combined-Shape",
      "fill": "#424242",
      "points": "21 206 21 131.433855 36.2169274 131.433855 36.2169274 83 21 83 21 28.5277769 72.5925844 28.5277769 72.5925844 183.30553 134.45104 183.30553 134.45104 227.00129 94.2857007 227.00129 94.2857007 206 21 206"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_22_",
      "fill": "url(#linearGradient-1)",
      "fill-rule": "nonzero",
      "points": "477 103 532.804224 103.507311 531.282291 263.310316"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_4_",
      "fill": "url(#linearGradient-2)",
      "fill-rule": "nonzero",
      "points": "222.537031 0 221.996537 107.017761 182 106.477267 182 0"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_21_",
      "fill": "url(#linearGradient-3)",
      "fill-rule": "nonzero",
      "points": "1026.18146 12 1026.18146 62.7319706 937 37.6329957"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_20_",
      "fill": "url(#linearGradient-4)",
      "fill-rule": "nonzero",
      "points": "808 146.704336 808.563616 12 855.9074 12 854.780167 146.704336"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_19_",
      "fill": "url(#linearGradient-5)",
      "fill-rule": "nonzero",
      "points": "391 219.367765 391.504065 102 434.853698 102.63442 433.845567 220.002185"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "XMLID_18_",
      "fill": "url(#linearGradient-6)",
      "fill-rule": "nonzero",
      "x": "0",
      "y": "195",
      "width": "109.829028",
      "height": "36.5991459"
    }
  })])])])])], 1), _vm._v(" "), _c('div', {
    ref: "rectangle",
    staticClass: "rectangle"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('div', {
    staticClass: "fb"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/lingitio/",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "fbIcon",
    attrs: {
      "width": "10px",
      "height": "20px",
      "viewBox": "0 0 10 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("fb")]), _vm._v(" "), _c('desc', [_vm._v("Facebook Ccon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-84.000000, -810.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.293314,6.47609191 L12.1283378,6.47609191 L12.1283378,4.40033119 C12.1283378,3.62078245 12.645001,3.43903954 13.0089008,3.43903954 C13.3719727,3.43903954 15.2423929,3.43903954 15.2423929,3.43903954 L15.2423929,0.0120057959 L12.1664252,0 C8.75181122,0 7.97474643,2.55599255 7.97474643,4.19167874 L7.97474643,6.47609191 L6,6.47609191 L6,10.0074519 L7.97474643,10.0074519 C7.97474643,14.5394328 7.97474643,20 7.97474643,20 L12.1283378,20 C12.1283378,20 12.1283378,14.4856137 12.1283378,10.0074519 L14.9310702,10.0074519 L15.293314,6.47609191 Z",
      "id": "fb"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "twitter"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/LING_IT",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "17px",
      "viewBox": "0 0 20 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("twitter")]), _vm._v(" "), _c('desc', [_vm._v("Twitter Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-78.000000, -860.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20,51.9239592 C19.2647626,52.2507764 18.4734994,52.4712259 17.6432617,52.56988 C18.4909567,52.0623998 19.1409374,51.258551 19.4474555,50.2996163 C18.6545683,50.770152 17.7768305,51.1115848 16.8418489,51.2959016 C16.09362,50.4985486 15.0270994,50 13.8469034,50 C11.5811055,50 9.74402696,51.8370785 9.74402696,54.1032824 C9.74402696,54.4244159 9.78015955,54.7374297 9.85039482,55.038264 C6.44012748,54.8669387 3.4163571,53.2336642 1.39252583,50.7510708 C1.03931957,51.3567992 0.837139435,52.0615878 0.837139435,52.8142825 C0.837139435,54.2376632 1.56141526,55.4937783 2.66244443,56.2294217 C1.99013458,56.2079045 1.3572052,56.0231817 0.80384873,55.7158517 C0.803442746,55.732903 0.803442746,55.7503603 0.803442746,55.7678176 C0.803442746,57.7555163 2.21789172,59.4135558 4.0951627,59.7911211 C3.75088809,59.8844975 3.38834419,59.9348395 3.01402675,59.9348395 C2.74932505,59.9348395 2.49233705,59.9092625 2.24184479,59.8609504 C2.76434647,61.490977 4.27947953,62.6776688 6.07474169,62.7105536 C4.67044232,63.8111767 2.90156913,64.4672472 0.978827924,64.4672472 C0.647950795,64.4672472 0.321133508,64.44776 0,64.4095975 C1.81637334,65.5743662 3.97296145,66.2531718 6.28991332,66.2531718 C13.8375657,66.2531718 17.9643952,60.001015 17.9643952,54.5786899 C17.9643952,54.4008688 17.9607413,54.2234537 17.9530276,54.0472566 C18.7544405,53.469947 19.4502974,52.7468891 20,51.9239592 Z",
      "id": "twitter"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dribbble"
  }, [_c('a', {
    attrs: {
      "href": "https://dribbble.com/Fliebau",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "dribbble",
    attrs: {
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("dribbble")]), _vm._v(" "), _c('desc', [_vm._v("Dribbble Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-78.000000, -908.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.7973201,105.986973 C19.6662469,105.344552 19.4692324,104.71184 19.2143678,104.107447 C18.9639532,103.513977 18.653261,102.942756 18.292405,102.408754 C17.9343808,101.879202 17.5237656,101.381609 17.0714819,100.92973 C16.6196029,100.477042 16.1216054,100.066022 15.5924578,99.7088068 C15.0584557,99.3467372 14.4864261,99.0372587 13.8937647,98.786035 C13.2893714,98.5315749 12.6570643,98.3341559 12.014239,98.2038917 C11.3560409,98.068773 10.67802,98 10.0008082,98 C9.3227873,98 8.6455755,98.068773 7.98656832,98.2038917 C7.34414757,98.3341559 6.71143594,98.5319794 6.10744716,98.786035 C5.5147857,99.0372587 4.94275614,99.3471418 4.40794491,99.7088068 C3.87839279,100.066022 3.38079989,100.476637 2.92892081,100.92973 C2.47663718,101.381609 2.06642645,101.879606 1.70880684,102.408754 C1.3475463,102.942756 1.0372587,103.513977 0.786844057,104.107447 C0.53076576,104.71184 0.33456043,105.344552 0.203082631,105.986973 C0.0683684554,106.644362 0,107.322383 0,107.999999 C0,108.678829 0.0683684554,109.35685 0.203082631,110.014644 C0.33456043,110.657064 0.531170307,111.289776 0.78643951,111.893765 C1.03685415,112.486426 1.3475463,113.059265 1.70840229,113.593267 C2.0660219,114.122819 2.47623264,114.619603 2.92851626,115.072291 C3.38039534,115.52417 3.87839279,115.934381 4.40754036,116.292405 C4.94235159,116.653666 5.51438115,116.963953 6.10704262,117.214368 C6.71062685,117.470446 7.34374302,117.665438 7.98616377,117.79732 C8.64517095,117.933248 9.32238275,118.001212 10.0004036,118.001212 C10.6776154,118.001212 11.3556363,117.933248 12.0138344,117.79732 C12.6570643,117.665438 13.2889668,117.470042 13.8933601,117.214368 C14.4860216,116.963953 15.0580512,116.653261 15.5920533,116.292405 C16.1216054,115.934381 16.6191983,115.524575 17.0710774,115.072291 C17.5229565,114.619603 17.9339763,114.122415 18.2920005,113.593267 C18.653261,113.059265 18.9635486,112.486426 19.2139632,111.893765 C19.4692324,111.29018 19.6658423,110.657064 19.7969156,110.014644 C19.9320343,109.356445 19.9999982,108.678425 19.9999982,107.999999 C20.0004028,107.322383 19.9324388,106.644362 19.7973201,105.986973 Z M18.5375605,107.915449 C18.4141737,107.888749 15.5240894,107.266555 12.5895049,107.635502 C12.529632,107.489461 12.4685453,107.342206 12.405436,107.194546 C12.2278398,106.776649 12.0364891,106.362393 11.8374519,105.955823 C15.2105654,104.579554 16.5799572,102.599296 16.5957346,102.575832 C17.7935985,104.029774 18.5181423,105.888263 18.5375605,107.915449 Z M15.6410035,101.59076 C15.6195625,101.623933 14.403494,103.47514 11.1800629,104.683522 C9.72005253,102.000971 8.11602338,99.8702211 7.98778196,99.7011204 C8.63343909,99.5445607 9.30660542,99.4600104 10.0004036,99.4600104 C12.1631123,99.4600104 14.1360884,100.265868 15.6410035,101.59076 Z M7.9546091,99.7079977 C7.9546091,99.7088068 7.95299091,99.7096159 7.95299091,99.7096159 C7.95299091,99.7096159 7.94368633,99.7120432 7.92790899,99.7152796 C7.93640448,99.7128523 7.94611361,99.7112341 7.9546091,99.7079977 Z M6.35624361,100.275982 C6.46992134,100.428496 8.04967766,102.569764 9.52789267,105.196892 C5.42699899,106.286338 1.86819838,106.24386 1.64246112,106.239815 C2.1974997,103.594481 3.97467499,101.401027 6.35624361,100.275982 Z M1.46001039,107.999999 C1.46001039,107.908976 1.46405586,107.819976 1.46729223,107.730166 C1.61778375,107.733403 5.83801881,107.82928 10.235041,106.513289 C10.4797919,106.992272 10.7140247,107.478942 10.9280301,107.965208 C10.8151615,107.996763 10.7026974,108.030745 10.5914469,108.067154 C5.98244212,109.556696 3.64456458,113.704113 3.64456458,113.704113 C3.64456458,113.704113 3.64780096,113.70654 3.64780096,113.708158 C2.28811825,112.194748 1.46001039,110.194262 1.46001039,107.999999 Z M10.0004036,116.541201 C7.93357265,116.541201 6.03786507,115.806544 4.56045916,114.584003 C4.6725187,114.675026 4.75180992,114.733281 4.75180992,114.733281 C4.75180992,114.733281 6.38901193,111.162748 11.4535367,109.398114 C11.4725504,109.390832 11.4915642,109.385573 11.5105779,109.379909 C12.7124872,112.502608 13.2084619,115.118005 13.3350852,115.864394 C12.3099629,116.300496 11.1832993,116.541201 10.0004036,116.541201 Z M14.7728455,115.084427 C14.6858679,114.56863 14.2307524,112.062056 13.1105615,108.983858 C15.8671453,108.542901 18.2568049,109.299 18.4327828,109.35685 C18.0525086,111.736396 16.6903986,113.789068 14.7728455,115.084427 Z",
      "id": "dribbble"
    }
  })])])])])])])]), _vm._v(" "), (_vm.menu) ? _c('div', {
    staticClass: "lineMobile"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu),
      expression: "menu"
    }],
    staticClass: "socialMobile"
  }, [_c('div', {
    ref: "fb",
    staticClass: "fb"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/lingitio/",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "fbIcon",
    attrs: {
      "width": "10px",
      "height": "20px",
      "viewBox": "0 0 10 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("fb")]), _vm._v(" "), _c('desc', [_vm._v("Facebook Ccon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-84.000000, -810.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.293314,6.47609191 L12.1283378,6.47609191 L12.1283378,4.40033119 C12.1283378,3.62078245 12.645001,3.43903954 13.0089008,3.43903954 C13.3719727,3.43903954 15.2423929,3.43903954 15.2423929,3.43903954 L15.2423929,0.0120057959 L12.1664252,0 C8.75181122,0 7.97474643,2.55599255 7.97474643,4.19167874 L7.97474643,6.47609191 L6,6.47609191 L6,10.0074519 L7.97474643,10.0074519 C7.97474643,14.5394328 7.97474643,20 7.97474643,20 L12.1283378,20 C12.1283378,20 12.1283378,14.4856137 12.1283378,10.0074519 L14.9310702,10.0074519 L15.293314,6.47609191 Z",
      "id": "fb"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    ref: "twitter",
    staticClass: "twitter"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/LING_IT",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "17px",
      "viewBox": "0 0 20 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("twitter")]), _vm._v(" "), _c('desc', [_vm._v("Twitter Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-78.000000, -860.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20,51.9239592 C19.2647626,52.2507764 18.4734994,52.4712259 17.6432617,52.56988 C18.4909567,52.0623998 19.1409374,51.258551 19.4474555,50.2996163 C18.6545683,50.770152 17.7768305,51.1115848 16.8418489,51.2959016 C16.09362,50.4985486 15.0270994,50 13.8469034,50 C11.5811055,50 9.74402696,51.8370785 9.74402696,54.1032824 C9.74402696,54.4244159 9.78015955,54.7374297 9.85039482,55.038264 C6.44012748,54.8669387 3.4163571,53.2336642 1.39252583,50.7510708 C1.03931957,51.3567992 0.837139435,52.0615878 0.837139435,52.8142825 C0.837139435,54.2376632 1.56141526,55.4937783 2.66244443,56.2294217 C1.99013458,56.2079045 1.3572052,56.0231817 0.80384873,55.7158517 C0.803442746,55.732903 0.803442746,55.7503603 0.803442746,55.7678176 C0.803442746,57.7555163 2.21789172,59.4135558 4.0951627,59.7911211 C3.75088809,59.8844975 3.38834419,59.9348395 3.01402675,59.9348395 C2.74932505,59.9348395 2.49233705,59.9092625 2.24184479,59.8609504 C2.76434647,61.490977 4.27947953,62.6776688 6.07474169,62.7105536 C4.67044232,63.8111767 2.90156913,64.4672472 0.978827924,64.4672472 C0.647950795,64.4672472 0.321133508,64.44776 0,64.4095975 C1.81637334,65.5743662 3.97296145,66.2531718 6.28991332,66.2531718 C13.8375657,66.2531718 17.9643952,60.001015 17.9643952,54.5786899 C17.9643952,54.4008688 17.9607413,54.2234537 17.9530276,54.0472566 C18.7544405,53.469947 19.4502974,52.7468891 20,51.9239592 Z",
      "id": "twitter"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    ref: "dribbble",
    staticClass: "dribbble"
  }, [_c('a', {
    attrs: {
      "href": "https://dribbble.com/Fliebau",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "dribbble",
    attrs: {
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("dribbble")]), _vm._v(" "), _c('desc', [_vm._v("Dribbble Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-78.000000, -908.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.7973201,105.986973 C19.6662469,105.344552 19.4692324,104.71184 19.2143678,104.107447 C18.9639532,103.513977 18.653261,102.942756 18.292405,102.408754 C17.9343808,101.879202 17.5237656,101.381609 17.0714819,100.92973 C16.6196029,100.477042 16.1216054,100.066022 15.5924578,99.7088068 C15.0584557,99.3467372 14.4864261,99.0372587 13.8937647,98.786035 C13.2893714,98.5315749 12.6570643,98.3341559 12.014239,98.2038917 C11.3560409,98.068773 10.67802,98 10.0008082,98 C9.3227873,98 8.6455755,98.068773 7.98656832,98.2038917 C7.34414757,98.3341559 6.71143594,98.5319794 6.10744716,98.786035 C5.5147857,99.0372587 4.94275614,99.3471418 4.40794491,99.7088068 C3.87839279,100.066022 3.38079989,100.476637 2.92892081,100.92973 C2.47663718,101.381609 2.06642645,101.879606 1.70880684,102.408754 C1.3475463,102.942756 1.0372587,103.513977 0.786844057,104.107447 C0.53076576,104.71184 0.33456043,105.344552 0.203082631,105.986973 C0.0683684554,106.644362 0,107.322383 0,107.999999 C0,108.678829 0.0683684554,109.35685 0.203082631,110.014644 C0.33456043,110.657064 0.531170307,111.289776 0.78643951,111.893765 C1.03685415,112.486426 1.3475463,113.059265 1.70840229,113.593267 C2.0660219,114.122819 2.47623264,114.619603 2.92851626,115.072291 C3.38039534,115.52417 3.87839279,115.934381 4.40754036,116.292405 C4.94235159,116.653666 5.51438115,116.963953 6.10704262,117.214368 C6.71062685,117.470446 7.34374302,117.665438 7.98616377,117.79732 C8.64517095,117.933248 9.32238275,118.001212 10.0004036,118.001212 C10.6776154,118.001212 11.3556363,117.933248 12.0138344,117.79732 C12.6570643,117.665438 13.2889668,117.470042 13.8933601,117.214368 C14.4860216,116.963953 15.0580512,116.653261 15.5920533,116.292405 C16.1216054,115.934381 16.6191983,115.524575 17.0710774,115.072291 C17.5229565,114.619603 17.9339763,114.122415 18.2920005,113.593267 C18.653261,113.059265 18.9635486,112.486426 19.2139632,111.893765 C19.4692324,111.29018 19.6658423,110.657064 19.7969156,110.014644 C19.9320343,109.356445 19.9999982,108.678425 19.9999982,107.999999 C20.0004028,107.322383 19.9324388,106.644362 19.7973201,105.986973 Z M18.5375605,107.915449 C18.4141737,107.888749 15.5240894,107.266555 12.5895049,107.635502 C12.529632,107.489461 12.4685453,107.342206 12.405436,107.194546 C12.2278398,106.776649 12.0364891,106.362393 11.8374519,105.955823 C15.2105654,104.579554 16.5799572,102.599296 16.5957346,102.575832 C17.7935985,104.029774 18.5181423,105.888263 18.5375605,107.915449 Z M15.6410035,101.59076 C15.6195625,101.623933 14.403494,103.47514 11.1800629,104.683522 C9.72005253,102.000971 8.11602338,99.8702211 7.98778196,99.7011204 C8.63343909,99.5445607 9.30660542,99.4600104 10.0004036,99.4600104 C12.1631123,99.4600104 14.1360884,100.265868 15.6410035,101.59076 Z M7.9546091,99.7079977 C7.9546091,99.7088068 7.95299091,99.7096159 7.95299091,99.7096159 C7.95299091,99.7096159 7.94368633,99.7120432 7.92790899,99.7152796 C7.93640448,99.7128523 7.94611361,99.7112341 7.9546091,99.7079977 Z M6.35624361,100.275982 C6.46992134,100.428496 8.04967766,102.569764 9.52789267,105.196892 C5.42699899,106.286338 1.86819838,106.24386 1.64246112,106.239815 C2.1974997,103.594481 3.97467499,101.401027 6.35624361,100.275982 Z M1.46001039,107.999999 C1.46001039,107.908976 1.46405586,107.819976 1.46729223,107.730166 C1.61778375,107.733403 5.83801881,107.82928 10.235041,106.513289 C10.4797919,106.992272 10.7140247,107.478942 10.9280301,107.965208 C10.8151615,107.996763 10.7026974,108.030745 10.5914469,108.067154 C5.98244212,109.556696 3.64456458,113.704113 3.64456458,113.704113 C3.64456458,113.704113 3.64780096,113.70654 3.64780096,113.708158 C2.28811825,112.194748 1.46001039,110.194262 1.46001039,107.999999 Z M10.0004036,116.541201 C7.93357265,116.541201 6.03786507,115.806544 4.56045916,114.584003 C4.6725187,114.675026 4.75180992,114.733281 4.75180992,114.733281 C4.75180992,114.733281 6.38901193,111.162748 11.4535367,109.398114 C11.4725504,109.390832 11.4915642,109.385573 11.5105779,109.379909 C12.7124872,112.502608 13.2084619,115.118005 13.3350852,115.864394 C12.3099629,116.300496 11.1832993,116.541201 10.0004036,116.541201 Z M14.7728455,115.084427 C14.6858679,114.56863 14.2307524,112.062056 13.1105615,108.983858 C15.8671453,108.542901 18.2568049,109.299 18.4327828,109.35685 C18.0525086,111.736396 16.6903986,113.789068 14.7728455,115.084427 Z",
      "id": "dribbble"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "menuButtonMobile",
    class: {
      activeM: _vm.menu
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menuButton"
  }, [_c('span', {
    ref: "line1",
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    ref: "line2",
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    ref: "line3",
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    ref: "clicker",
    staticClass: "clicker",
    on: {
      "click": _vm.workMenuClicked
    }
  }), _vm._v(" "), _c('div', {
    ref: "workNavi",
    staticClass: "workNavigation"
  }, [_c('ul', [_c('li', {
    attrs: {
      "id": "home"
    },
    on: {
      "click": _vm.workLinkClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "work"
    },
    on: {
      "click": _vm.workLinkClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Work")])]) : _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Projekte")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "about"
    },
    on: {
      "click": _vm.workLinkClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("About us")])]) : _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("Über uns")])])], 1)]), _vm._v(" "), _c('div', {
    ref: "lang",
    staticClass: "lang"
  }, [_c('div', {
    staticClass: "en",
    on: {
      "click": _vm.toggleEn
    }
  }, [_c('p', {
    class: {
      active: _vm.english
    }
  }, [_vm._v("EN")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "de",
    on: {
      "click": _vm.toggleDe
    }
  }, [_c('p', {
    class: {
      active: !_vm.english
    }
  }, [_vm._v("DE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "navigation"
  }, [_c('ul', {
    ref: "navi"
  }, [_c('li', {
    attrs: {
      "id": "home"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "work"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Work")])]) : _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Projekte")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "about"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("About us")])]) : _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("Über uns")])])], 1)]), _vm._v(" "), _c('div', {
    ref: "lang",
    staticClass: "lang"
  }, [_c('div', {
    staticClass: "en",
    on: {
      "click": _vm.toggleEn
    }
  }, [_c('p', {
    class: {
      active: _vm.english
    }
  }, [_vm._v("EN")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "de",
    on: {
      "click": _vm.toggleDe
    }
  }, [_c('p', {
    class: {
      active: !_vm.english
    }
  }, [_vm._v("DE")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu),
      expression: "menu"
    }],
    ref: "menu",
    staticClass: "navigationMobile"
  }, [_c('ul', [_c('li', {
    ref: "link1",
    attrs: {
      "id": "home"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1), _vm._v(" "), _c('li', {
    ref: "link2",
    attrs: {
      "id": "work"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Work")])]) : _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Projekte")])])], 1), _vm._v(" "), _c('li', {
    ref: "link3",
    attrs: {
      "id": "about"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("About us")])]) : _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("Über uns")])])], 1)]), _vm._v(" "), _c('div', {
    ref: "language",
    staticClass: "lang"
  }, [_c('div', {
    staticClass: "en",
    on: {
      "click": _vm.toggleEn
    }
  }, [_c('p', {
    class: {
      active: _vm.english
    }
  }, [_vm._v("EN")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "de",
    on: {
      "click": _vm.toggleDe
    }
  }, [_c('p', {
    class: {
      active: !_vm.english
    }
  }, [_vm._v("DE")])])]), _vm._v(" "), (_vm.english) ? _c('router-link', {
    staticClass: "legalLink",
    attrs: {
      "to": "legal"
    }
  }, [_vm._v("Legal")]) : _c('router-link', {
    staticClass: "legalLink",
    attrs: {
      "to": "legal"
    }
  }, [_vm._v("Impressum")])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "duration": 900
    },
    on: {
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "leave": _vm.leave
    }
  }, [_c('router-view', {
    ref: "view"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lineBreaker"
  }, [_c('p', [_vm._v("|")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b6e8d06","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/App-Component.vue
// module id = 38
// module chunks = 1